var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2488 2.02655H18.9599V7.62939e-05H12.2345L9.99949 7.96105H9.93836L7.72366 7.62939e-05H0.978027V2.0265H1.66887C1.82857 2.05161 1.97674 2.1226 2.09408 2.23023C2.21141 2.33785 2.29246 2.47712 2.32667 2.62988V11.1673C2.29035 11.3145 2.20753 11.4473 2.08968 11.5471C1.97183 11.6469 1.82478 11.7089 1.66887 11.7245H0.978027V13.7509H6.3726V11.7245H5.02396V2.75026H5.10264L8.21134 13.7509H10.6497L13.799 2.75026H13.8652V11.7245H12.5164V13.7509H18.9599V11.7245H18.2488C18.0964 11.7053 17.9538 11.6417 17.8399 11.5421C17.7259 11.4426 17.6462 11.3118 17.6113 11.1673V2.62994C17.6443 2.47994 17.7224 2.3427 17.8358 2.23537C17.9492 2.12805 18.0929 2.05541 18.2488 2.02655Z",
    fill: "#141414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.2a942ef5.svg";
export { ForwardRef as ReactComponent };